/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Projects_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "The people you invite, each as a viewer, editor, or admin. Editors can upload and create; admins also manage members and settings. This keeps every project's..." |
*
* @param {Uno_Edu_Intro_Projects_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_projects_chip2_answer = /** @type {((inputs?: Uno_Edu_Intro_Projects_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Projects_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die von Ihnen eingeladenen Personen, jeweils als Betrachter, Bearbeiter oder Administrator. Bearbeiter können hochladen und erstellen; Administratoren verwalten zusätzlich Mitglieder und Einstellungen. So bleibt der Kontext jedes Projekts privat für seine Mitglieder.")
	return /** @type {LocalizedString} */ ("The people you invite, each as a viewer, editor, or admin. Editors can upload and create; admins also manage members and settings. This keeps every project's context private to its members.")
});